module.exports = __webpack_public_path__ + "static/img/recruitbanner.8056963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/recruitbanner.png
// module id = +uz4
// module chunks = 1